import { cardTitle } from '../../assets/jss/wisene-material-dashboard-pro-react-types';
import { connect } from 'react-redux';
import { sendTestNotification } from '../../stores/actions/dashboardActions';
import Button from '../../../components/CustomButtons/ButtonTS';
import Card from '../../../components/Card/CardTS';
import CardHeader from '../../../components/Card/CardHeader';
import CardBody from '../../../components/Card/CardBody';
import CardIcon from '../../../components/Card/CardIcon.js';
import dashboardStyle from '../../assets/jss/views/dashboardStyleTS';
import Loading from '../../components/Loading/Loading';
import ErrorComponent from '../ErrorComponent/ErrorComponent';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import styles from '../../assets/jss/views/dashboardStyle';
import Notifications from '@material-ui/icons/Notifications'; 
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import React, { useState, useEffect } from 'react';


const style = {
	cardTitle,
	cardCategory: styles.cardCategory,
};

interface ITestNotificationCardProps {
	hideAlert: () => void;
    mobileView: boolean;
	systemID: number;
    systemVersion: string;
    testNotificationSuccess: boolean;
    testNotificationFailed: boolean;
    sendTestNotification: (systemID: number, severity: string, systemVersion: string) => void;
}

const TestNotificationCard  = (props: ITestNotificationCardProps) => {
    const {hideAlert, systemID, systemVersion, sendTestNotification, testNotificationSuccess, 
           testNotificationFailed} = props;
    const [severity, setSeverity] = useState("L1");
    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {
        if (testNotificationSuccess || testNotificationFailed) {
            hideAlert();
        }
    }, [testNotificationSuccess, testNotificationFailed]);

    const onSubmit = () => {
        setSubmitted(true);
        sendTestNotification(systemID, severity, systemVersion);
    };

    const button = () => {
        if (submitted && !testNotificationSuccess && !testNotificationFailed) {
            return (
                <div style={{ width: '100%', marginTop: '25px', marginBottom: '10px', paddingLeft: '10px', paddingTop: '5px' }}>
                    <Loading transform={1} height={17} width={40} color='darkGray' />
                </div>);
        }
        return(
            <Button
                color='info'
                onClick={onSubmit}
                className='downloadButton' >
                Send
            </Button>);
    }

    return (
        <ErrorComponent Children message='Error'>
            <Card chart style={{ overflow: 'visible', marginTop: '10px', marginBottom: '0' }} className='node-edit-card'>
            <CardHeader color='info' icon>
                <CardIcon color='info'>
                   <Notifications/>
                </CardIcon>
                <h3 style={{ ...style.cardTitle, textAlign: 'left' }}>{"Test notification"}</h3>
            </CardHeader>
            <CardBody>
                <form>
                <GridContainer style={{ margin: '0 0 0 -15px' }}>
                    <GridItem xs={12} style={{ margin: '25px 0 0 0' }}>
                    <FormControl style={{width: '50%'}}>
                    <InputLabel id="test-notif-select-label">Severity</InputLabel>
                    <Select
                        labelId="test-notif-select-label"
                        id="test-notif-select"
                        value={severity}
                        label="Severity"
                        onChange={e => setSeverity(e.target.value)}
                        MenuProps={{
                            disablePortal: true //to show menuitems on the alert, not behind it
                        }}
                    >
                        <MenuItem value={"heartbeat"}>Heartbeat</MenuItem>
                        <MenuItem value={"L1"}>L1</MenuItem>
                        <MenuItem value={"L2"}>L2</MenuItem>
                        <MenuItem value={"L3"}>L3</MenuItem>
                        <MenuItem value={"L4"}>L4</MenuItem>
                        <MenuItem value={"obstruction"}>Obstruction</MenuItem>
                        <MenuItem value={"system_notification"}>System</MenuItem>
                        
                    </Select>
                    </FormControl>                     
                    </GridItem>
                    
                    <GridItem xs={12} style={{ margin: '25px 0 0 0' }}>
                        {button()}
                    </GridItem>
                </GridContainer>
                </form>
        </CardBody >
        </Card>
    </ErrorComponent>
    );
}



const mapStateToProps = (state) => {
    return {
        testNotificationSuccess: state.dashboard.testNotificationSuccess,
        testNotificationFailed: state.dashboard.testNotificationFailed,
        moblieView: state.dashboard.mobileView
    }
}
const actions = { sendTestNotification };
export const ExportCardWithStyles = dashboardStyle(TestNotificationCard);
export default connect(mapStateToProps, actions)(ExportCardWithStyles);
